import Vue from "vue";
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)


import Login from '../pages/login.vue'

// Administrator
import AdminDashboard from '../pages/admin/dashboard.vue'
import AdminProfile from '../pages/admin/profile.vue'
import AdminMain from '../pages/admin/main.vue'

import AdminProjects from '../pages/admin/projects.vue'
import AdminProject from '../pages/admin/project.vue'
import AdminCreateProject from '../pages/admin/components/createProject.vue'
import AdminUpdateProject from '../pages/admin/components/updateProject.vue'

import AdminProjectContracts from '../pages/admin/projectContracts.vue'
import AdminProjectContract from '../pages/admin/projectContract.vue'
import AdminCreateProjectContract from '../pages/admin/components/createProjectContract.vue'
import AdminUpdateProjectContract from '../pages/admin/components/updateProjectContract.vue'

import AdminProjectTransactions from '../pages/admin/projectsTransactions.vue'
import AdminProjectTransaction from '../pages/admin/projectTransaction.vue'
import AdminCreateProjectTransaction from "../pages/admin/components/createProjectTransaction"
import AdminUpdateProjectTransaction from "../pages/admin/components/updateProjectTransaction"

import AdminProjectValuations from '../pages/admin/projectsValuations.vue'

import AdminProjectAccounts from '../pages/admin/projectsAccounts.vue'
import AdminProjectAccount from '../pages/admin/projectAccount.vue'
// import AdminCreateProjectAccount from "../pages/admin/components/createProjectAccount"
// import AdminUpdateProjectAccount from "../pages/admin/components/updateProjectAccount"

import AdminInvestors from '../pages/admin/investors.vue'
import AdminInvestorDashboard from '../pages/admin/investorDashboard.vue'
import AdminInvestorReport from '../pages/admin/investorReport.vue'
import AdminInvestor from '../pages/admin/investor.vue'
import AdminCreateInvestor from '../pages/admin/components/createInvestor.vue'
import AdminUpdateInvestor from '../pages/admin/components/updateInvestor.vue'

import AdminInvestorTransactionRequests from '../pages/admin/investorsTransactionRequests.vue'

// import AdminInvestorContractRequests from '../pages/admin/investorsContractRequests.vue'


import AdminInvestorTransactions from '../pages/admin/investorsTransactions.vue'
import AdminInvestorTransaction from '../pages/admin/investorTransaction.vue'
import AdminCreateInvestorTransaction from "../pages/admin/components/createInvestorTransaction"
import AdminUpdateInvestorTransaction from "../pages/admin/components/updateInvestorTransaction"

import AdminInvestorAccounts from '../pages/admin/investorsAccounts.vue'
import AdminInvestorAccount from '../pages/admin/investorAccount.vue'
// import AdminCreateProjectAccount from "../pages/admin/components/createProjectAccount"
// import AdminUpdateProjectAccount from "../pages/admin/components/updateProjectAccount"

import AdminClusters from '../pages/admin/clusters.vue'
import AdminCluster from '../pages/admin/cluster.vue'

import AdminAssets from '../pages/admin/assets.vue'
import AdminAsset from '../pages/admin/asset.vue'

import AdminPlans from '../pages/admin/plans.vue'
import AdminPlan from '../pages/admin/plan.vue'

import AdminCreatePlan from '../pages/admin/components/createPlan.vue'
import AdminUpdatePlan from '../pages/admin/components/updatePlan.vue'

import AdminInvestorContracts from '../pages/admin/investorContracts.vue'
import AdminInvestorContract from '../pages/admin/investorContract.vue'
import AdminCreateInvestorContract from '../pages/admin/components/createInvestorContract.vue'
import AdminUpdateInvestorContract from '../pages/admin/components/updateInvestorContract.vue'

import AdminNews from '../pages/admin/news.vue'
import AdminLibrary from '../pages/admin/library.vue'

import InvestorReport from '../pages/investor/report.vue'
import InvestorContract from '../pages/investor/contract.vue'
// import InvestorRequestContract from '../pages/investor/requestNewContract.vue'

// Investor
import InvestorDashboard from '../pages/investor/dashboard.vue'
import InvestorMain from '../pages/investor/main.vue'
import InvestorProfile from '../pages/investor/profile.vue'

// import InvestorProjects from '../pages/investor/projects.vue'
// import InvestorProject from '../pages/investor/project.vue'

import NotFound from '../pages/notFound.vue'

const routes = [
    { path: '/login', alias: ['/', '/home'], component: Login, meta: { requiresGuest: true } },

    { path: '*', component: NotFound },
    // Admin Pages
    {
        path: '/administrator',
        component: AdminMain,
        meta: { requiresAuth: true },
        children: [
            { path: 'dashboard', alias: [''], component: AdminDashboard, meta: { requiresAuth: true } },
            { path: 'profile', component: AdminProfile, meta: { requiresAuth: true } },
            { path: 'news', component: AdminNews, meta: { requiresAuth: true } },
            { path: 'library', component: AdminLibrary, meta: { requiresAuth: true } },

            { path: 'projects/contracts', component: AdminProjectContracts, meta: { requiresAuth: true } },
            { path: 'projects/contract/:contractName/:contractId', component: AdminProjectContract, meta: { requiresAuth: true }, props: true, name: 'projectContract' },
            { path: 'projects/contracts/create', component: AdminCreateProjectContract, meta: { requiresAuth: true } },
            { path: 'project/:projectId/contract/update/:contractId', component: AdminUpdateProjectContract, meta: { requiresAuth: true } },


            { path: 'projects', component: AdminProjects, meta: { requiresAuth: true } },
            { path: 'projects/create', component: AdminCreateProject, meta: { requiresAuth: true } },
            { path: 'project/:projectCode/update/:projectId', component: AdminUpdateProject, meta: { requiresAuth: true } },
            { path: 'project/:projectCode/:projectId', component: AdminProject, meta: { requiresAuth: true }, props: true, name: 'project' },

            { path: 'projects/valuations', component: AdminProjectValuations, meta: { requiresAuth: true } },

            { path: 'projects/transactions', component: AdminProjectTransactions, meta: { requiresAuth: true } },
            { path: 'projects/transaction/:transactionName/:transactionId', component: AdminProjectTransaction, meta: { requiresAuth: true }, props: true },
            { path: 'projects/transactions/create', component: AdminCreateProjectTransaction, meta: { requiresAuth: true }, props: true },
            { path: 'projects/transaction/:transactionCode/update/:transactionId', component: AdminUpdateProjectTransaction, meta: { requiresAuth: true }, props: true },

            { path: 'projects/accounts', component: AdminProjectAccounts, meta: { requiresAuth: true } },
            { path: 'projects/account/:accountCode/:accountId', component: AdminProjectAccount, meta: { requiresAuth: true }, props: true, name: 'projectAccount' },

            { path: 'clusters', component: AdminClusters, meta: { requiresAuth: true } },
            { path: 'cluster/:clusterName/:clusterId', component: AdminCluster, meta: { requiresAuth: true }, props: true, name: 'cluster' },

            { path: 'assets', component: AdminAssets, meta: { requiresAuth: true } },
            { path: 'asset/:assetName/:assetId', component: AdminAsset, meta: { requiresAuth: true }, props: true, name: 'asset' },

            { path: 'plans', component: AdminPlans, meta: { requiresAuth: true } },
            { path: 'plan/:planName/:planId', component: AdminPlan, meta: { requiresAuth: true }, props: true, name: 'plan' },
            { path: 'plans/create', component: AdminCreatePlan, meta: { requiresAuth: true } },
            { path: 'plan/:planName/update/:planId', component: AdminUpdatePlan, meta: { requiresAuth: true } },

            { path: 'investors/contracts', component: AdminInvestorContracts, meta: { requiresAuth: true } },
            { path: 'investor/contract/:contractId', component: AdminInvestorContract, meta: { requiresAuth: true }, props: true, name: 'investorContract' },
            { path: 'investors/contracts/create', component: AdminCreateInvestorContract, meta: { requiresAuth: true } },
            { path: 'investor/:investorId/contract/update/:contractId', component: AdminUpdateInvestorContract, meta: { requiresAuth: true } },

            { path: 'investors', component: AdminInvestors, meta: { requiresAuth: true } },
            { path: 'investor/:investorCode/:investorId', component: AdminInvestor, meta: { requiresAuth: true }, props: true, name: 'investor' },
            { path: 'investors/create', component: AdminCreateInvestor, meta: { requiresAuth: true } },
            { path: 'investor/:investorName/update/:investorId', component: AdminUpdateInvestor, meta: { requiresAuth: true } },


            { path: 'investors/transactions', component: AdminInvestorTransactions, meta: { requiresAuth: true } },
            { path: 'investors/transaction/:transactionName/:transactionId', component: AdminInvestorTransaction, meta: { requiresAuth: true }, props: true, name: 'transaction' },
            { path: 'investors/transactions/create', component: AdminCreateInvestorTransaction, meta: { requiresAuth: true }, props: true },
            { path: 'investors/transaction/:transactionCode/update/:transactionId', component: AdminUpdateInvestorTransaction, meta: { requiresAuth: true }, props: true },

            { path: 'investors/transaction-requests', component: AdminInvestorTransactionRequests, meta: { requiresAuth: true } },

            // { path: 'investors/contract-requests', component: AdminInvestorContractRequests, meta: { requiresAuth: true } },


            { path: 'investors/accounts', component: AdminInvestorAccounts, meta: { requiresAuth: true } },
            { path: 'investors/account/:accountCode/:accountId', component: AdminInvestorAccount, meta: { requiresAuth: true }, props: true, name: 'investorAccount' },

        ],
        beforeEnter: (to, from, next) => {
            let user = store.state.userStore.authUser
            if (user && user.userable_type !== 'administrator')
                next({ path: '/' + user.userable_type })
            else
                next()
        }
    },

    {
        path: '/administrator',
        component: InvestorMain,
        meta: { requiresAuth: true },
        children: [
            { path: 'investor/:investorCode/dashboard/:investorId', alias: [''], component: AdminInvestorDashboard, meta: { requiresAuth: true } },
            { path: 'investor/:investorCode/:investorId/contract/:contractCode/:contractID/report/:year', alias: [''], component: AdminInvestorReport, meta: { requiresAuth: true } },

        ],
        beforeEnter: (to, from, next) => {
            let user = store.state.userStore.authUser
            if (user && user.userable_type !== 'administrator')
                next({ path: '/' + user.userable_type })
            else
                next()
        }
    },

    // Instructor Pages
    {
        path: '/investor',
        component: InvestorMain,
        meta: { requiresAuth: true },
        children: [
            // Main
            {
                path: 'dashboard', alias: [''], component: InvestorDashboard, meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    let user = store.state.userStore.authUser
                    if (user.force_password_change) {
                        next('/investor/profile');
                    } else {
                        next()
                    }
                }
            },
            { path: 'profile', component: InvestorProfile, meta: { requiresAuth: true } },
            { path: 'contract/:contractCode/:contractID/report/:year', component: InvestorReport, meta: { requiresAuth: true } },
            { path: 'contract/:contractCode', component: InvestorContract, meta: { requiresAuth: true } },
            // {
            //     path: 'contracts/create', component: InvestorRequestContract, meta: { requiresAuth: true }, props: true,
            // },


            // { path: 'projects', component: InvestorProjects, meta: { requiresAuth: true } },
            // { path: 'project/:projectName/:projectId', component: InvestorProject, meta: { requiresAuth: true }, props: true, name: 'project' },
        ],
        beforeEnter: (to, from, next) => {
            let user = store.state.userStore.authUser
            if (user && user.userable_type !== 'investor')
                next({ path: '/' + user.userable_type })
            else
                next()
        }
    },

]

export default new VueRouter({
    mode: 'history',
    routes
})


// WEBPACK FOOTER //
// ./resources/js/router/index.js